// src/Public/navbar-data.js

const NavbarData = {
    en: {
        // Nav Links
        home: 'Home',
        shop: 'Shop',
        categories: 'Categories',
        services: 'Programs',
        about: 'About Us',
        ourWork: 'Our Work',
        blogs: 'Blogs',
        contact: 'Contact',
        admin: 'Admin',
        logout: 'Log Out',

        navItems: [
            { id: 1, name: 'Home',     value: '/' },
            { id: 2, name: 'Services', value: '/services' },
            { id: 6, name: 'Our Work', value: '/our-work' },
            { id: 3, name: 'Guides',   value: '/blog' },
            { id: 4, name: 'About',    value: '/about' },
            { id: 5, name: 'Contact',  value: '/contact' },
        ],

        // Top Bar Texts
        topBarSubtitle: 'Professional Garage Door Hardware & Parts',
        shippingPromo: 'FAST SHIPPING',

        // Modal Specific (for ModalNavbar)
        modal: {
            back: 'Back',
            viewAll: 'View All in',
            searchPlaceholder: 'Search SKU, Part Name...',
        },

        // Banner Messages (Promo text in the center)
        bannerMessages: [
            { text: "SAVE 25% OFF YOUR FIRST BULK ORDER!", value: "/register" },
            { text: "SAME DAY SHIPPING ON ORDERS BEFORE 2PM EST", value: "/shipping-policy" },
            { text: "B2B WHOLESALE PRICING FOR INSTALLERS", value: "/about" }
        ]
    },

    he: {
        // Nav Links
        home: 'בית',
        shop: 'חנות',
        categories: 'קטגוריות',
        services: 'שירותים',
        blogs: 'בלוגים',
        about: 'אודותינו',
        ourWork: 'עבודות שלנו',
        contact: 'צור קשר',
        admin: 'אדמין',
        logout: 'התנתק',

        navItems: [
            { id: 1, name: 'Home',     value: '/' },
            { id: 2, name: 'Services', value: '/services' },
            { id: 6, name: 'Our Work', value: '/our-work' },
            { id: 3, name: 'Guides',   value: '/blog' },
            { id: 4, name: 'About',    value: '/about' },
            { id: 5, name: 'Contact',  value: '/contact' },
        ],

        // Top Bar Texts
        topBarSubtitle: 'פרזול וחלפים מקצועיים לדלתות מוסך',
        shippingPromo: 'משלוח חינם בהזמנות מעל 49.99$',

        // Modal Specific (for ModalNavbar)
        modal: {
            back: 'חזרה',
            viewAll: 'לכל האפשרויות ב-',
            searchPlaceholder: 'חיפוש מק"ט, שם חלק...',
        },

        // Banner Messages (Promo text in the center)
        bannerMessages: [
            { text: "חסוך 25% בהזמנה הסיטונאית הראשונה שלך!", value: "/register" },
            { text: "משלוח באותו יום להזמנות עד השעה 14:00", value: "/shipping-policy" },
            { text: "תמחור סיטונאי (B2B) למתקינים", value: "/about" }
        ]
    }
};

function resolveLanguage(language) {
    return language === 'he' ? 'he' : 'en';
}

export function getNavbarData(language) {
    const lang = resolveLanguage(language);
    return NavbarData[lang] || NavbarData.en;
}

export default NavbarData;